import {
  imageCardImageFrameSx,
  imageCardSurfaceSx,
  imageCardTextSectionSx,
} from "../../../components/ImageCard/imageCardChromeSx";
import { insightsDesignEnabled } from "../../../common/utils/insightsDesignEnabled";
import { statisticCardContainerSx } from "../constants";
import { brandRed, cardShadow, ink, paper, stone } from "./designTokens";

export function insightsImageCardSurfaceSx() {
  if (!insightsDesignEnabled()) {
    return imageCardSurfaceSx;
  }

  return {
    height: "100%",
    width: "100%",
    p: 2,
    backgroundColor: paper,
    border: `1px solid ${stone}`,
    borderRadius: 0,
    boxShadow: "none",
    transition: "box-shadow 0.15s ease",
    "&:hover": {
      boxShadow: cardShadow,
    },
  };
}

export function insightsImageCardImageFrameSx() {
  if (!insightsDesignEnabled()) {
    return {
      ...imageCardImageFrameSx,
      overflow: "hidden",
    };
  }

  return {
    position: "relative",
    width: "100%",
    pb: "100%",
    backgroundColor: paper,
    border: `1px solid ${stone}`,
    borderRadius: 0,
    overflow: "hidden",
  };
}

export function insightsImageCardTextSectionSx() {
  if (!insightsDesignEnabled()) {
    return imageCardTextSectionSx;
  }

  return {};
}

export function insightsImageCardTitleSx() {
  if (!insightsDesignEnabled()) {
    return {
      mt: 1.5,
      mb: 0,
      fontWeight: "bold",
      fontSize: "0.9rem",
      textTransform: "capitalize",
      lineHeight: 1.25,
    };
  }

  return {
    mt: 1.5,
    mb: 0,
    fontWeight: 700,
    fontSize: "0.9rem",
    color: ink,
    textTransform: "capitalize",
    lineHeight: 1.25,
  };
}

export function insightsMetricChipSx({ size = "small", variant = "default" } = {}) {
  if (!insightsDesignEnabled()) {
    return variant === "primary" ? { fontWeight: 700 } : undefined;
  }

  const isPrimary = variant === "primary";

  return {
    height: "auto",
    borderRadius: isPrimary ? 0 : undefined,
    backgroundColor: isPrimary ? brandRed : undefined,
    color: isPrimary ? paper : undefined,
    "& .MuiChip-label": {
      whiteSpace: "normal",
      py: size === "medium" ? 0.75 : 0.5,
      fontWeight: size === "medium" ? 700 : 500,
      fontSize: size === "medium" ? "0.875rem" : "0.75rem",
      color: isPrimary ? paper : undefined,
    },
  };
}

export function insightsKeyValueCardSurfaceSx(additionalSx = {}) {
  if (!insightsDesignEnabled()) {
    return {
      ...statisticCardContainerSx,
      p: 2,
      width: "100%",
      height: "100%",
      borderRadius: 0,
      ...additionalSx,
    };
  }

  return {
    p: 2,
    width: "100%",
    height: "100%",
    backgroundColor: paper,
    border: `2px solid ${stone}`,
    borderRadius: 0,
    boxShadow: "none",
    ...additionalSx,
  };
}

export function insightsKeyValueCardLabelSx() {
  if (!insightsDesignEnabled()) {
    return {
      m: 0,
      fontSize: "0.875rem",
      fontWeight: "bold",
      textTransform: "uppercase",
      color: "text.secondary",
    };
  }

  return {
    m: 0,
    fontSize: "14px",
    fontWeight: 700,
    textTransform: "uppercase",
    letterSpacing: "0.06em",
    color: ink,
  };
}

export function insightsKeyValueCardValueSx() {
  if (!insightsDesignEnabled()) {
    return {
      m: 0,
      fontSize: { xs: "1.75rem", md: "2rem" },
      fontWeight: "bold",
      lineHeight: 1.2,
      color: "text.primary",
    };
  }

  return {
    m: 0,
    fontSize: { xs: "1.75rem", md: "2rem" },
    fontWeight: 800,
    lineHeight: 1.2,
    color: ink,
  };
}

export function insightsAccordionTitleSx() {
  if (!insightsDesignEnabled()) {
    return { fontWeight: "bold" };
  }

  return { fontWeight: 700 };
}
